import { render } from "./ProfileHistoryTable.vue?vue&type=template&id=757b176a"
import script from "./ProfileHistoryTable.vue?vue&type=script&lang=js"
export * from "./ProfileHistoryTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/frontend/js/components/ProfileHistoryTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "757b176a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('757b176a', __exports__)) {
    api.reload('757b176a', __exports__)
  }
  
  module.hot.accept("./ProfileHistoryTable.vue?vue&type=template&id=757b176a", () => {
    api.rerender('757b176a', render)
  })

}


export default __exports__